import { useTranslation } from 'react-i18next';
import { CollapseProperties } from '../data/LockerDataTypes';
import CollapseComponent from './CollapseComponent';
import PlaceSelector from './PlaceSelector';

const PlaceSelectorContainer = () => {
    const { t } = useTranslation();
    const properties: CollapseProperties = {
        componentId: "collapse-selector",
        textShowButton: t('hideSelectedLocker'),
        textHideButton: t('showSelectedLocker')
    };

    return (
        <div className="locker-place-selector-container">
            <CollapseComponent properties={properties}><PlaceSelector/></CollapseComponent>
        </div>
    )
}

export default PlaceSelectorContainer;

